import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../appContext';
import CircularProgress from '../components/CircularProgress';
import { LOGIN } from './paths';

/**
 * A layout route: everything nested under it requires a signed-in user.
 *
 * The check waits for the session to resolve rather than treating "not yet
 * known" as "not signed in", which would bounce a returning user to the login
 * page on every refresh. Where they were going is remembered so they land
 * there after signing in.
 */
const RequireAuth = () => {
  const { isAuthenticated, authStateLoading } = useContext(AuthContext);
  const location = useLocation();

  if (authStateLoading) return <CircularProgress />;
  if (!isAuthenticated) return <Navigate to={LOGIN} state={{ from: location }} replace />;

  return <Outlet />;
};

export default RequireAuth;
